import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-card-floating',
  templateUrl: './card-floating.component.html',
  styleUrls: ['./card-floating.component.css']
})
export class CardFloatingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
